import styled from "styled-components"

const LeftTabListStyled = styled.div`
    border-radius: 4px;
    margin-right: 8px;
    overflow: hidden;
    align-self: flex-start;
`

const TabItemStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 84px;
    height: 84px;
    padding: 10px;
    box-sizing: border-box;
    background-color: #fff;
    flex-shrink: 0;
    color: #6E727C;
    font-size: 14px;
    svg path{
        fill: #6E727C;
    }

    ${props => props.$active && `
        color: #11BBA6;
        svg path{
            fill: #11BBA6;
        }
    `}
    &:hover {
        cursor: pointer;
        color: #11BBA6;
        svg path{
            fill: #11BBA6;
        }
    }
`

const icon1 = <div dangerouslySetInnerHTML={{
    __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="小助手" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="默认未选中编辑状态" transform="translate(-79.000000, -239.000000)" fill="#11BBA6" fill-rule="nonzero">
            <g id="编组-2" transform="translate(48.000000, 148.000000)">
                <g id="模块管理备份" transform="translate(31.000000, 91.000000)">
                    <g id="f-idea" transform="translate(4.416814, 2.062500)">
                        <path d="M8.78371396,16.3620823 L4.38541686,16.3620823 C3.96762668,16.3620823 3.62895801,16.700751 3.62895801,17.1185411 C3.62895801,17.5363313 3.96762668,17.875 4.38541686,17.875 L8.7837344,17.875 C9.20152458,17.875 9.54019326,17.5363313 9.54019326,17.1185411 C9.54019326,16.700751 9.20150414,16.3620823 8.78371396,16.3620823 Z M12.6513858,4.02131481 C12.3196889,3.23715321 11.8450416,2.53303313 11.2405492,1.92856118 C10.6360977,1.32408922 9.93197761,0.849421511 9.14781601,0.517744972 C8.3355632,0.174210429 7.47313878,0 6.58456541,0 C5.69599204,0 4.83356761,0.174210429 4.02131481,0.517765417 C3.23715321,0.849441956 2.53303313,1.32410966 1.92858162,1.92858162 C1.32410966,2.53305358 0.849441956,3.23715321 0.517744972,4.02133526 C0.174189984,4.8336085 0,5.69601249 0,6.58458585 C0,7.72916943 0.298433239,8.8567838 0.863037771,9.84553685 C1.3388095,10.6786638 1.99519089,11.4016136 2.7763471,11.9566499 L2.7763471,14.4607332 C2.7763471,14.8785234 3.11501577,15.217192 3.53280595,15.217192 L9.63634531,15.217192 C10.0541355,15.217192 10.3928042,14.8785234 10.3928042,14.4607332 L10.3928042,11.9566499 C11.1739604,11.401634 11.8303418,10.6786843 12.3061135,9.84553685 C12.870718,8.8567838 13.1691513,7.72916943 13.1691513,6.58458585 C13.1691513,5.69599204 12.9949408,4.83358806 12.6513858,4.02131481 Z M8.43425042,7.19118407 L6.68942696,9.77745555 C6.54330773,9.99404812 6.3046143,10.1109313 6.06162745,10.1109313 C5.91105906,10.1109313 5.76393251,10.0658962 5.63925763,9.98147455 C5.29294259,9.74783099 5.20159507,9.27766115 5.43523863,8.93132566 L6.38430826,7.52457798 L5.36200524,7.52457798 C5.08761,7.52458272 4.83472751,7.37599634 4.70117686,7.13629451 C4.56762621,6.89659268 4.57435079,6.60336539 4.71874943,6.37003777 L6.16088712,4.03965383 C6.38075086,3.68440439 6.84697485,3.57463608 7.20222428,3.79447938 C7.55747372,4.01432268 7.66724203,4.48054667 7.44739873,4.8357961 L6.71972621,6.01163983 L7.80714603,6.01163983 C8.08688039,6.01163064 8.34378509,6.16599695 8.47510093,6.41299385 C8.60641676,6.65999074 8.59070509,6.95929347 8.43425042,7.19118407 L8.43425042,7.19118407 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />

const icon2 = <div dangerouslySetInnerHTML={{
    __html: `
<?xml version="1.0" encoding="UTF-8"?>
<svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>切片</title>
    <g id="小助手" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="完善简历" transform="translate(-79.000000, -159.000000)" fill="#11BBA6" fill-rule="nonzero">
            <g id="编组-6" transform="translate(48.000000, 66.000000)">
                <g id="模块管理" transform="translate(31.000000, 93.000000)">
                    <g id="01_neirongguanli" transform="translate(2.983750, 2.750000)">
                        <path d="M12.5827338,8.5467626 L12.5827338,16.0251799 C12.5827338,16.381295 12.4640288,16.5 12.1079137,16.5 L1.18705036,16.5 C0.356115115,16.5 0,16.0251798 0,15.3129496 L0,1.18705034 C0,0.356115094 0.474820153,0 1.30575538,0 L11.3956835,0 C12.2266187,0 12.5827338,0.356115115 12.5827338,1.30575538 L12.5827338,8.5467626 Z M6.29136691,4.74820143 L9.97122301,4.74820143 C10.3273381,4.74820143 10.5647482,4.39208632 10.5647482,4.03597122 C10.5647482,3.67985613 10.3273381,3.32374099 9.97122301,3.32374099 L2.61151078,3.32374099 C2.3741007,3.32374099 2.13669065,3.56115107 2.13669065,3.91726618 C2.13669065,4.2733813 2.25539569,4.51079135 2.61151078,4.62949639 C2.73021582,4.74820143 2.9676259,4.74820143 3.20503597,4.74820143 L6.29136691,4.74820143 L6.29136691,4.74820143 Z M5.57913668,8.90287769 L8.19064748,8.90287769 C8.66546763,8.90287769 9.02158273,8.66546761 9.02158273,8.19064748 C9.02158273,7.71582733 8.66546761,7.47841727 8.19064748,7.47841727 L2.84892086,7.47841727 C2.3741007,7.47841727 2.01798561,7.71582735 2.01798561,8.19064748 C2.01798561,8.66546763 2.37410073,8.90287769 2.84892086,8.90287769 L5.57913668,8.90287769 Z M5.69784172,11.6330935 L2.84892086,11.6330935 C2.49280574,11.6330935 2.25539569,11.9892086 2.25539569,12.3453237 C2.25539569,12.7014388 2.49280576,12.9388489 2.84892086,13.0575539 L8.78417265,13.0575539 C9.14028777,12.9388489 9.37769782,12.7014388 9.25899281,12.3453237 C9.25899281,11.9892086 8.90287769,11.7517986 8.42805756,11.7517986 C7.47841727,11.6330935 6.52877699,11.6330935 5.69784172,11.6330935 L5.69784172,11.6330935 Z M14.0071943,9.85251798 L14.0071943,3.67985611 C14.0071943,3.32374099 14.1258993,3.20503595 14.3633094,3.32374099 L15.0755396,3.32374099 C15.6690648,3.44244603 16.0251799,3.79856114 16.0251799,4.39208632 L16.0251799,15.3129496 C16.0251799,15.9064748 15.5503597,16.381295 14.9568345,16.381295 C14.0071943,16.381295 14.0071943,16.381295 14.0071943,15.4316547 L14.0071943,9.85251798 Z" id="形状"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`}} />

const LeftTabList = ({ activeKey = 'resume', onChange }) => {
    const TabList = [
        { key: 'resume', label: '我的简历', icon: icon2, color: '#00A7F2' },
        { key: 'question', label: '面试问题', icon: icon1, color: '#FF9B6E' },
    ]

    const handleClickTab = (key) => {
        onChange && onChange(key)
    }

    return <LeftTabListStyled>
        {
            TabList.map(item => {
                return <TabItemStyled onClick={() => handleClickTab(item.key)} $active={activeKey === item.key} key={item.key} className="tab-item">
                    {item.icon}
                    <span>{item.label}</span>
                </TabItemStyled>
            })
        }
    </LeftTabListStyled>
}

export default LeftTabList